import { DefaultDeviceContract, PosTerminalStatus } from 'models'
import createDispatchAction, {
    AppThunk,
    createDispatchActionSet,
} from './base.action'
import { showErrorMessage } from './ui.action'
import posTerminalService from 'Services/api/posTerminal.service'

import { clearPermission } from './otherModuleAction.action'

export const getPosTerminalActions = createDispatchActionSet<any>(
    'GET_POS_TERMINAL',
)

export const getCurrentPosTerminalActions = createDispatchActionSet<any>(
    'GET_CURRENT_POS_TERMINAL',
)

export const POS_TERMINAL_SET_OPEN_CASH_DRAWER =
    'POS_TERMINAL_SET_OPEN_CASH_DRAWER'

export const UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA =
    'UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA'

export const getCurrentPosTerminal = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getCurrentPosTerminalActions.pending())
        const terminal = (await posTerminalService.getCurrentPosTerminalInfo())
            .data
        dispatch(getCurrentPosTerminalActions.success(terminal))
        // Clear the pin code as initial
        dispatch(clearPermission())
    } catch (error) {
        dispatch(showErrorMessage(error))
    }
}

export const getCurrentPosTerminalStatusActions = createDispatchActionSet<
    PosTerminalStatus
>('GET_POS_TERMINAL_STATUS')

export const getCurrentPosTerminalStatus = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getCurrentPosTerminalStatusActions.pending())
        const res = await posTerminalService.getCurrentPosTerminalStatus()
        dispatch(getCurrentPosTerminalStatusActions.success(res.data))
    } catch (error) {
        dispatch(showErrorMessage(error))
        dispatch(getCurrentPosTerminalStatusActions.failed(error))
    }
}

export const getCurrentPosTerminalDeviceActions = createDispatchActionSet<
    DefaultDeviceContract
>('GET_POS_TERMINAL_DEVICE')

export const getCurrentPosTerminalDevice = (
    isBgProcess?: boolean,
): AppThunk => async (dispatch) => {
    try {
        if (!isBgProcess) dispatch(getCurrentPosTerminalDeviceActions.pending())
        const res = await posTerminalService.getCurrentPostTerminalDevice()
        dispatch(getCurrentPosTerminalDeviceActions.success(res.data))
    } catch (error) {
        dispatch(showErrorMessage(error))
        dispatch(getCurrentPosTerminalDeviceActions.failed(error))
    }
}

export const setCashDrawerOpened = (value: boolean | undefined): AppThunk => (
    dispatch,
) => {
    dispatch(createDispatchAction(POS_TERMINAL_SET_OPEN_CASH_DRAWER, value))
}
